import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/main.scss';
import vuetify from '@/plugins/vuetify';
import wb from './registerServiceWorker';
import { Plugin } from 'vue-fragment';
import vueDebounce from 'vue-debounce';
import httpService from './services/httpService';
import { tokenService } from './services/tokenService';
import { userService } from './services/userService';

if (tokenService.getToken()) {
  httpService.setHeader();
  httpService.mount401Interceptor();
  store.commit('user/setUser', userService.getUser());
}

Vue.prototype.$workbox = wb;
Vue.use(Plugin);
Vue.use(vueDebounce);
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
